import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import {
	rejectCancellation,
	resetCancellationData,
} from '@acorn-portal/shared/src/store/cancellation/cancellation.slice';
import { safelyConsoleError } from '@acorn-portal/shared/src/utils/safely-console-error';

/**
 * Hook for rejecting active cancellation transaction and clearing local state.
 * Does not handle navigation - that's left to the caller.
 */
export const useRejectCancellation = () => {
	const dispatch = useAppDispatch();
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const cancellation = useAppSelector((state) => state.cancellation);

	/**
	 * Rejects the cancellation transaction and resets the cancellations redux state.
	 */
	const rejectAndReset = useCallback(async () => {
		const transactionId = cancellation.cancellationRatingResponse?.transactionId;
		const midJourney = !cancellation.takenUp;
		const policyReference = fullPolicy.policyNumber;

		if (transactionId && policyReference && midJourney) {
			try {
				await dispatch(
					rejectCancellation({
						policyReference,
						transactionId,
						rejectionReason: 'CustomerChangedMind',
					}),
				).unwrap();
			} catch (error) {
				safelyConsoleError('Reject cancellation failed', error);
			}
		}

		// Always clean store, even if API call fails
		dispatch(resetCancellationData());
	}, [cancellation.cancellationRatingResponse?.transactionId, fullPolicy.policyNumber, dispatch]);

	return {
		rejectAndReset,
	};
};
